window.$ = window.jQuery = require("jquery");
$.mask = window.mask = require("jquery-mask-plugin");

require("owl.carousel");
require("bootstrap/js/dist/modal");
require("lightgallery");
require("lg-zoom");
require("lg-fullscreen");
require("lg-video");
LazyLoad = require("vanilla-lazyload");

if (location.hash == "#politica-de-privacidade") {
  location.href = "/politica-de-privacidade";
}

// VARS
window.$window = $(window);
window.$body = $("body");
const $isMobile = $window.width() < 1024;

// CHAVES GMAPS
var key_gmaps_1 = "AIzaSyDhTJDx2sXVDA4xQbYOtWgkdvLspWgybvY"; // prod
window.key_gmaps = "AIzaSyB8H7PGo8gAbA8o_rwODadh3I6Ea27e8zE"; // dev

if (
  location.href.indexOf("setin.com.br") > 0 ||
  location.href.indexOf("setinvendas.com.br") > 0
) {
  window.key_gmaps = key_gmaps_1;
}

// BREAKPOINTS
var md = 1200,
  ww = $window.width();
window.tablet = ww >= 768 && ww < md;
window.desk = ww > md;

$(function () {
  let path = location.pathname;
  setInterval(updateButtonVisibility, 60000);

  // if (shouldShowButton() && !$isMobile) {
  //   const button = document.querySelector(".floating-whatsapp-button");
  //   if (button) {
  //     if (shouldShowButton()) {
  //       button.classList.remove("floating-whatsapp-button--hidden");
  //     } else {
  //       button.classList.add("floating-whatsapp-button--hidden");
  //     }
  //   }
  // }

  window.getOriginFromReferrer = () => {
    let origin = 'Acesso Direto';
    const location = document.location.href;
    const referrer = document.referrer;

    switch (true) {
      case location.includes('utm_source'):
        const urlObject = new URL(location);
        const searchParams = new URLSearchParams(urlObject.search);
        origin = searchParams.get('utm_source') || origin;
        break;
      case location.includes('gclid'):
        origin = 'Google Adwords';
        break;
      case location.includes('fbclid'):
        origin = 'Facebook Ads';
        break;
    }

    if (
      referrer.includes('google.com') &&
      origin === 'Acesso Direto'
    ) {
      origin = 'Google Orgânico';
    } /* else {
      origin = getDomainName(referrer);
    } */

    return origin;
 };
  window.getTrackingData = function() {
    const trackingData = {
      origem: '',
      referencia_raw: '',
      referencia: '',
      historico_id: '',
      pagina: window.location.pathname || ''
    };
    
    try {
      const getCookie = (name) => {
      try {
        return document.cookie
        .split('; ')
        .find(row => row.startsWith(`${name}=`))
        ?.split('=')[1];
      } catch {
        return null;
      }
      };
    
      const hubidRawref = getCookie('hubid_rawref');
      if (hubidRawref) {
      const decoded = JSON.parse(atob(hubidRawref));
      trackingData.origem = decoded.origem || trackingData.origem;
      trackingData.referencia_raw = decoded.url || document.referrer || trackingData.referencia_raw;
      trackingData.referencia = decoded.referrer || document.referrer || trackingData.referencia;
      }
    
      if (!trackingData.referencia_raw) {
      trackingData.referencia_raw = document.referrer || '';
      }
    
      const hubidUser = getCookie('hubid_user');
      if (hubidUser) {
      try {
        trackingData.historico_id = JSON.parse(atob(hubidUser)).history_id || '';
      } catch (e) {
        console.error('Error parsing hubid_user:', e);
      }
      }
    
    } catch (error) {
      console.error('Tracking error:', error);
      trackingData.origem = window.getOriginFromReferrer()
      trackingData.referencia_raw = document.referrer || '';
      trackingData.referencia = document.referrer || '';
      trackingData.pagina = window.location.pathname || '';
    }
    
    return trackingData;
    };

  window.optionsLG = {
    controls: $window.width() > 768,
    download: false,
    youtubePlayerParams: {
      modestbranding: 1,
      showinfo: 0,
      rel: 0,
      controles: 0,
    },
  };

  //Botão Flutuante  Voltar ao Topo
  $(".scroll-top-button").on("click", function () {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  });

  $(window).on("scroll", () => {
    const isScrolledPastHalf = window.scrollY > window.innerHeight / 2;
    const chatButton = $(".floating-chat-button:not(.floating-chat-button--inside-menu)");
    const whatsappButton = $(".floating-whatsapp-button:not(.floating-whatsapp-button--inside-menu)");
  
    if (isScrolledPastHalf) {
      chatButton.removeClass("floating-chat-button--hidden");
      if (path === '/' && $isMobile) {
        whatsappButton.removeClass("floating-whatsapp-button--hidden");
      }
    } else {
      chatButton.addClass("floating-chat-button--hidden");
      if (path === '/' && $isMobile) {
        whatsappButton.addClass("floating-whatsapp-button--hidden");
      }
    }
  });

  //Header Mobile Status
  $(".open-status").on("click", function (e) {
    e.preventDefault();
    $(this).toggleClass("rotate");
    $(".side-menu__itens").toggleClass("open");
  });
  // BT MENU
  $(".bt-menu").on("click", function () {
    $("header").toggleClass("open-menu");
  });
  $(".bg-menu").on("click", function () {
    $("header").removeClass("open-menu");
  });

  // ANIMACOES DE SCROLL
  window.onscroll = () => animation(window.scrollY);
  animation(window.scrollY);

  // IMG TO BG
  $(".imgtobg").each(function (i, el) {
    var src = $("img", el).hide().attr("src");
    $(el).css({ "background-image": "url(" + src + ")" });
  });

  //LP ALTO PADRÃO SCROLL
  $(".altopadrao .bt-scroll").on("click", function (e) {
    e.preventDefault();

    var pos = $("#itens").offset().top;
    pos -= window.desk ? 70 : 0;

    $("body,html").animate({ scrollTop: pos }, 500);
  });

  // SUBMENU
  if (!desk) {
    $(".dropdown > a").on("click", function (e) {
      e.preventDefault();
      var sub = $(this).parents(".dropdown");
      sub.toggleClass("dropdown-open");
    });
    $(".menu-documentacao > a").on("click", function (e) {
      e.preventDefault();
      $(this).parent().toggleClass("open");
    });

    $(document).ready(function () {
      $(".side-menu__link > input[type='checkbox']").on("change", function () {
          var menu = $(this).parent();
          var dropdown = menu.find(".vertical-dropdown");
  
          if (this.checked) {
              // Fecha todos os outros menus antes de abrir um novo
              $(".side-menu__link").not(menu).removeClass("open").find(".vertical-dropdown").slideUp(300);
              $(".side-menu__link > input[type='checkbox']").not(this).prop("checked", false);
  
              // Abre o menu atual
              menu.addClass("open");
              dropdown.stop().slideDown(300);
          } else {
              // Fecha o menu atual
              menu.removeClass("open");
              dropdown.stop().slideUp(300);
          }
      });
    });
  }

  //CARROSSEL HOME
  if ($isMobile) {
    $(".home .featured-properties-section .owl-carousel").owlCarousel({
      items: 1,
      margin: 15,
      nav: false,
      navText: [],
      navElement: "div",
      navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
      lazyLoad: true,
      dots: true,
      autoHeight: true,
    });

    $(".blog-section__card-list").owlCarousel({
      items: 1,
      margin: 15,
      nav: false,
      navText: [],
      navElement: "div",
      navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
      lazyLoad: true,
      dots: true,
      autoHeight: true,
    });

    $(".home .residential-section__card-list").owlCarousel({
      items: 1,
      margin: 15,
      nav: false,
      navText: [],
      navElement: "div",
      navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
      lazyLoad: true,
      dots: true,
      autoHeight: true,
    });

    $(".errors .featured-properties-section__card-list").owlCarousel({
      items: 1,
      margin: 15,
      nav: false,
      navText: [],
      navElement: "div",
      navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
      lazyLoad: true,
      lazyLoadEager: 1,
      dots: false,
      autoHeight: true,
    });
  }

  // Listagem Imoveis Home
  if (!desk) {
    $(".listagem-home .owl-carousel").owlCarousel({
      items: 1,
      margin: 20,
      dots: false,
    });
  }

  // CARROSSEL
  $(".home .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  // CARROSSEL
  $(".home .fase-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  // CARROSEL FICHA ZONA OESTE BAIRROS PERDIZES
  $(".bairrosperdizes .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 20,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
			900: {
        items: 3,
				nav: true,
				dots: false,
			}
		}
  });

  // CARROSSEL DE IMAGEN DO CARD
  $(".bairrosperdizes .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  $(".bairrosvilamariana .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 20,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
			900: {
        items: 3,
				nav: true,
				dots: false,
			}
		}
  });

  // CARROSSEL DE IMAGEN DO CARD
  $(".bairrosvilamariana .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  $(".bairrosbrooklin .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 20,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
			900: {
        items: 3,
				nav: true,
				dots: false,
			}
		}
  });

  $(".bairrospinheiros .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 20,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
			900: {
        items: 3,
				nav: true,
				dots: false,
			}
		}
  });

  $(".salas-comerciais .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 35,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
			900: {
        items: 3,
				nav: true,
				dots: false,
			}
		}
  });

  $(".salas-comerciais .localidades__card-list").owlCarousel({
    items: 1,
    margin: 54,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
			900: {
        items: 3,
				nav: true,
				dots: false,
			}
		}
  });

  $(".bairrosipiranga .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 20,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
			900: {
        items: 3,
				nav: true,
				dots: false,
			}
		}
  });

  $(".bairroscentro .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 20,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
			900: {
        items: 3,
				nav: true,
				dots: false,
			}
		}
  });

  $(".bairrositaim .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 20,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
			900: {
        items: 3,
				nav: true,
				dots: false,
			}
		}
  });

  // CARROSSEL DE IMAGEN DO CARD
  $(".bairrosbrooklin .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  $(".bairrospinheiros .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  $(".salas-comerciais .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  $(".bairrosipiranga .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  $(".bairroscentro .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  $(".bairrositaim .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

    // CARROSEL FICHA ZONA SUL BAIRROS JARDINS
  $(".bairrosjardins .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 20,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
      900: {
        items: 3,
        nav: true,
        dots: false,
      }
    }
  });
  
    // CARROSSEL DE IMAGEN DO CARD
  $(".bairrosjardins .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

    // CARROSEL FICHA ZONA SUL BAIRROS IBIRAPUERA
  $(".bairrosibirapuera .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 20,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
      900: {
        items: 3,
        nav: true,
        dots: false,
      }
    }
  });

    // CARROSEL CAMPANHA PARAISO
  $(".campanha-paraiso .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 20,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
      900: {
        items: 3,
        nav: true,
        dots: false,
      }
    }
  });

   // CARROSEL ALTO PADRÃO
   $(".bairrosaltopadrao .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 20,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
      900: {
        items: 3,
        nav: true,
        dots: false,
      }
    }
  });
  
    // CARROSSEL DE IMAGEN DO CARD
  $(".bairrosibirapuera .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  $(".campanha-paraiso .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  $(".bairrosaltopadrao .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  $(".investproperties .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 15,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
			900: {
        items: 3,
				nav: true,
				dots: false,
			}
		}
  });

  $(".investpropertiesEn .similar-properties-section__card-list").owlCarousel({
    items: 1,
    margin: 15,
    nav: false,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: true,
    lazyLoad: true,
    loop: false,
    responsive: {
			900: {
        items: 3,
				nav: true,
				dots: false,
			}
		}
  });

  // CARROSSEL DE IMAGEN DO CARD
  $(".investproperties .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  $(".investpropertiesEn .residential-card__carousel>.owl-carousel").owlCarousel({
    items: 1,
    margin: 0,
    nav: true,
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-thin-left", "owl-next icon-thin-right"],
    lazyLoad: true,
    dots: false,
    touchDrag: false, //ativa ou desativa o swipe touch
  });

  if ($isMobile) {
		  
		$('.bairrosperdizes .servicos-carousel').owlCarousel({
			navText: [],
			navElement: 'div',
			navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
			smartSpeed: 700,
			nav: false,
			dots: true,
			items: 1,
			margin: 20,
    });

    $('.bairrosvilamariana .servicos-carousel').owlCarousel({
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 700,
      nav: false,
      dots: true,
      items: 1,
      margin: 20,
    });

    $('.bairrosbrooklin .servicos-carousel').owlCarousel({
			navText: [],
			navElement: 'div',
			navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
			smartSpeed: 700,
			nav: false,
			dots: true,
			items: 1,
			margin: 20,
		});

    $('.bairrospinheiros .servicos-carousel').owlCarousel({
			navText: [],
			navElement: 'div',
			navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
			smartSpeed: 700,
			nav: false,
			dots: true,
			items: 1,
			margin: 20,
		});

    $('.salas-comerciais .servicos-carousel').owlCarousel({
			navText: [],
			navElement: 'div',
			navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
			smartSpeed: 700,
			nav: false,
			dots: true,
			items: 1,
			margin: 20,
		});

    $('.bairrosipiranga .servicos-carousel').owlCarousel({
			navText: [],
			navElement: 'div',
			navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
			smartSpeed: 700,
			nav: false,
			dots: true,
			items: 1,
			margin: 20,
		});

    $('.bairroscentro .servicos-carousel').owlCarousel({
			navText: [],
			navElement: 'div',
			navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
			smartSpeed: 700,
			nav: false,
			dots: true,
			items: 1,
			margin: 20,
		});

    $('.bairrositaim .servicos-carousel').owlCarousel({
			navText: [],
			navElement: 'div',
			navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
			smartSpeed: 700,
			nav: false,
			dots: true,
			items: 1,
			margin: 20,
		});

    $('.bairroscentro .bairros-carousel').owlCarousel({
      autoHeight: true,
			navText: [],
			navElement: 'div',
			navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
			smartSpeed: 700,
			nav: false,
			dots: true,
			items: 1,
			margin: 20,
		});

    $('.bairrositaim .bairros-carousel').owlCarousel({
      autoHeight: true,
			navText: [],
			navElement: 'div',
			navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
			smartSpeed: 700,
			nav: false,
			dots: true,
			items: 1,
			margin: 20,
		});

    $('.investproperties .servicos-carousel').owlCarousel({
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 700,
      nav: false,
      dots: true,
      items: 1,
      margin: 20,
    });

    $('.investpropertiesEn .servicos-carousel').owlCarousel({
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 700,
      nav: false,
      dots: true,
      items: 2,
      margin: 20,
    });

    $('.investpropertiesEn .explore-carousel').owlCarousel({
      autoHeight: true,
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 700,
      nav: false,
      dots: true,
      items: 1,
      margin: 20,
    });

    $('.investpropertiesEn .rentabilizar-escolha-carousel').owlCarousel({
      autoHeight: true,
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 700,
      nav: false,
      dots: true,
      items: 1,
      margin: 20,
    });

    $('.investpropertiesEn .condominium-carousel').owlCarousel({
      autoHeight: true,
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 400,
      nav: false,
      dots: true,
      items: 2,
      margin: 20,
    });

    $('.bairrosjardins .servicos-carousel').owlCarousel({
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 700,
      nav: false,
      dots: true,
      items: 1,
      margin: 20,
    });

    $('.especificos-carousel').owlCarousel({
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 700,
      nav: false,
      dots: true,
      items: 1,
      margin: 20,
    });

    $('.regiao-paraiso-carousel').owlCarousel({
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 700,
      nav: false,
      dots: true,
      items: 1,
      margin: 40,
      autoHeight: true,
    });

    $('.padrao-carousel-paraiso').owlCarousel({
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 700,
      nav: false,
      dots: true,
      items: 1,
      margin: 20,
    });

    $('.pronto-morar-paraiso').owlCarousel({
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 700,
      nav: false,
      dots: true,
      items: 1,
      margin: 20,
    });

    $('.padrao-carousel').owlCarousel({
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 700,
      nav: false,
      dots: true,
      items: 1,
      margin: 20,
    });

    $('.temas-carousel').owlCarousel({
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 700,
      nav: false,
      dots: true,
      items: 1,
      margin: 20,
      autoHeight: true,
    });

    $('.bairrosibirapuera .servicos-carousel').owlCarousel({
      navText: [],
      navElement: 'div',
      navClass: ['owl-prev icon-prev', 'owl-next icon-next'],
      smartSpeed: 700,
      nav: false,
      dots: true,
      items: 1,
      margin: 20,
    });
	}

  // BT HOME
  
  $(".btn-play-home").on("click", function (e) {
      e.preventDefault();
      $(this).hide();
  });
  
  // BT VIDEO
  $(".bairrosperdizes .btn-play").on("click", function (e) {
    e.preventDefault();
    $(this)
      .parent()
      .addClass("playing")
      .siblings("iframe")
      .attr("src", function () {
        return $(this).data("src");
      });
  });

  $(".bairrosvilamariana .btn-play").on("click", function (e) {
    e.preventDefault();
    $(this)
      .parent()
      .addClass("playing")
      .siblings("iframe")
      .attr("src", function () {
        return $(this).data("src");
      });
  });

  $(".bairrosbrooklin .btn-play").on("click", function (e) {
    e.preventDefault();
    $(this)
      .parent()
      .addClass("playing")
      .siblings("iframe")
      .attr("src", function () {
        return $(this).data("src");
      });
  });

  $(".bairrospinheiros .btn-play").on("click", function (e) {
    e.preventDefault();
    $(this)
      .parent()
      .addClass("playing")
      .siblings("iframe")
      .attr("src", function () {
        return $(this).data("src");
      });
  });

  $(".salas-comerciais .btn-play").on("click", function (e) {
    e.preventDefault();
    $(this)
      .parent()
      .addClass("playing")
      .siblings("iframe")
      .attr("src", function () {
        return $(this).data("src");
      });
  });

  $(".bairrosjardins .btn-play").on("click", function (e) {
    e.preventDefault();
    $(this)
      .parent()
      .addClass("playing")
      .siblings("iframe")
      .attr("src", function () {
        return $(this).data("src");
      });
  });

  $(".bairrosibirapuera .btn-play").on("click", function (e) {
    e.preventDefault();
    $(this)
      .parent()
      .addClass("playing")
      .siblings("iframe")
      .attr("src", function () {
        return $(this).data("src");
      });
  });

  $(".campanha-paraiso .btn-play").on("click", function (e) {
    e.preventDefault();
    $(this)
      .parent()
      .addClass("playing")
      .siblings("iframe")
      .attr("src", function () {
        return $(this).data("src");
      });
  });

  $(".bairrosaltopadrao .btn-play").on("click", function (e) {
    e.preventDefault();
    $(this)
      .parent()
      .addClass("playing")
      .siblings("iframe")
      .attr("src", function () {
        return $(this).data("src");
      });
  });

  $(".investproperties .btn-play").on("click", function (e) {
    e.preventDefault();
    $(this)
      .parent()
      .addClass("playing")
      .siblings("iframe")
      .attr("src", function () {
        return $(this).data("src");
      });
  });

  $(".investpropertiesEn .btn-play").on("click", function (e) {
    e.preventDefault();
    $(this)
      .parent()
      .addClass("playing")
      .siblings("iframe")
      .attr("src", function () {
        return $(this).data("src");
      });
  });

  // BT VIDEO
  $('.btn-play').on('click', function (e) {
    e.preventDefault();
    $(this).parent().addClass('playing').siblings('iframe').attr('src', function () { return $(this).data('src'); })
  });

  // TAB BUTTON
  document.querySelectorAll('[data-tab]').forEach(el => {
    el.querySelectorAll('[data-tab-index="0"]').forEach(el => el.classList.add('active'));

    $(".tab-btn").on("click", function (e) {
        let index = e.currentTarget.getAttribute('data-tab-index');
        el.querySelectorAll('[data-tab-index').forEach(el => el.classList.remove('active'));
        el.querySelectorAll(`[data-tab-index="${index}"]`).forEach(el => el.classList.add('active'));
    })

  })

  //Tabs
  document.querySelectorAll('.tabs__button').forEach(button => {
      button.addEventListener('click', () =>{
          const sidebar = button.parentElement;
          const tabsContainer = sidebar.parentElement;
          const tabNumber = button.dataset.forTab;
          const tabToActivate = tabsContainer.querySelector(`.tabs__content[data-tab="${tabNumber}"]`);

          sidebar.querySelectorAll('.tabs__button').forEach(button => {
              button.classList.remove('tabs__button--active');
          });

          tabsContainer.querySelectorAll('.tabs__content').forEach(tab => {
              tab.classList.remove('tabs__content--active')
          });

          button.classList.add('tabs__button--active');
          tabToActivate.classList.add('tabs__content--active');
      });
  });


  // ACCORDION

  // ACORDION ESG
  if ($isMobile) { //se o cliente mudar de ideia ou o texto for maior, retire o if.
    const $estrutura = $('.estrutura-title');
    if ($estrutura.length) {
      $estrutura.scrollLeft(269)
    }
    var chevronUp = '<svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-up" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M1.646 10.354a.5.5 0 0 0 .708 0L8 4.707l5.646 5.647a.5.5 0 0 0 .708-.708l-6-6a.5.5 0 0 0-.708 0l-6 6a.5.5 0 0 0 0 .708z"/></svg>';
    var chevronDown = '<svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>';

    // Inicialmente, definir todos os botões como inativos
    $('.accordion .accordion-button').each(function() {
        $(this).removeClass('active').html('Ler mais ' + chevronDown)
            .css({
                'background-color': '#004A8F',
                'color': '#fff',
                'text-align': 'center',
                'font-size': '15px',
                'font-weight': '700',
            });
    });

    // Inicialmente, ocultar todo o conteúdo do accordion
    $('.accordion p.dentro').hide();

    $('.accordion .accordion-button').click(function(j) {
        var dropDown = $(this).closest('.accordion-item').find('p.dentro');
        var isActive = $(this).hasClass('active');

        // Alternar estado do botão clicado
        if (isActive) {
            $(this).removeClass('active').html('Ler mais ' + chevronDown)
                .css({
                    'background-color': '#004A8F',
                    'color': '#fff',
                    'text-align': 'center'
                });
            dropDown.slideUp();
        } else {
            $(this).addClass('active').html('Ler menos ' + chevronUp)
                .css({
                    'background-color': '#d8d8d8',
                    'color': '#004A8F',
                    'text-align': 'center'
                });
            dropDown.slideDown();
        }

        j.preventDefault();
    });

  }  
  // }


  // BTN CONTATO
  $(".bairrosperdizes .js-open-form, .modal-contato .btn-close").on("click", function (e) {
    e.preventDefault();
    $("body").toggleClass("modal-form-open");
  });

  $(".bairrosvilamariana .js-open-form, .modal-contato .btn-close").on("click", function (e) {
    e.preventDefault();
    $("body").toggleClass("modal-form-open");
  });

  $(".bairrosbrooklin .js-open-form, .modal-contato .btn-close").on("click", function (e) {
    e.preventDefault();
    $("body").toggleClass("modal-form-open");
  });

  $(".bairrospinheiros .js-open-form, .modal-contato .btn-close").on("click", function (e) {
    e.preventDefault();
    $("body").toggleClass("modal-form-open");
  });

  $(".salas-comerciais .js-open-form, .modal-contato .btn-close").on("click", function (e) {
    e.preventDefault();
    $("body").toggleClass("modal-form-open");
  });

  $(".bairrosjardins .js-open-form, .modal-contato .btn-close").on("click", function (e) {
    e.preventDefault();
    $("body").toggleClass("modal-form-open");
  });

  $(".bairrosibirapuera .js-open-form, .modal-contato .btn-close").on("click", function (e) {
    e.preventDefault();
    $("body").toggleClass("modal-form-open");
  });

  $(".investproperties .js-open-form, .modal-contato .btn-close").on("click", function (e) {
    e.preventDefault();
    $("body").toggleClass("modal-form-open");
  });

  $(".investpropertiesEn .js-open-form, .modal-contato .btn-close").on("click", function (e) {
    e.preventDefault();
    $("body").toggleClass("modal-form-open");
  });

  setTimeout(() => {
    // Banner Home
    $(".banner-home .item").each(function () {
      $(this).attr("data-pos", $(this).index() + 1);
    });
    var bannerHome = $(".banner-home .owl-carousel").owlCarousel({
      items: 1,
      loop: true,
      autoplay: true,
      navSpeed: 500,
      navText: [],
      navElement: "div",
      navClass: ["owl-prev icon-arrow-left", "owl-next icon-arrow-right"],
      lazyLoad: true,
      animateIn: "fadeIn",
      animateOut: "fadeOut",
      responsive: {
        1200: {
          nav: true,
        },
      },
    });

    $(".banner-home .owl-dots, .banner-home .owl-nav").hover(
      function () {
        bannerHome.trigger("stop.owl.autoplay");
        bannerHome.data("owl.carousel").options.animateIn = false;
        bannerHome.data("owl.carousel").options.animateOut = false;
      },
      function () {
        bannerHome.trigger("play.owl.autoplay");
        bannerHome.data("owl.carousel").options.animateIn = true;
        bannerHome.data("owl.carousel").options.animateOut = true;
      }
    );
  });

  // LAZY LOAD

  // LOCALIZACAO HOME
  $(".localizacao-home").attr("data-bg", function () {
    return desk ? $(this).data("bg-d") : $(this).data("bg-m");
  });

  // CONTEUDO SETIN HOME
  $(".blog-home .img").attr("data-bg", function () {
    var bg = window.desk ? $(this).data("bg-desk") : $(this).data("bg-mob");
    return bg;
  });

  new LazyLoad({
    elements_selector: ".lazy",
    threshold: 0,
  });

  // MODAL ZOOM - LIGHT GALLERY

  // 1. Modal Videos Home
  $(".listagem-videos").lightGallery(Object.assign({}, optionsLG));

  // 2. Modal Video
  $(".abre-video").on("click", function (e) {
    e.preventDefault();
    var idyt = $(this).data("idyt");
    var dynamic = {
      counter: false,
      zoom: false,
      dynamic: true,
      dynamicEl: [{ src: "https://www.youtube.com/watch?v=" + idyt }],
    };
    $(this).lightGallery(Object.assign(dynamic, optionsLG));
  });

  // 3. Modal Banner
  $(".popup-home").lightGallery(
    Object.assign(
      { selector: ".item a", zoom: false, counter: false },
      optionsLG
    )
  );

  // 4. Modal Plantas Alto Padrão
  $(".planta-altopadrao").lightGallery(
    Object.assign({ selector: ".item a" }, optionsLG)
  );

  // BT VER VIDEOS
  $(".diferenciais-home .bt-todos").on("click", function (e) {
    e.preventDefault();
    $(".listagem-videos").addClass("open");
    $(this).remove();
  });

  // TAB IMOVEIS HOME
  if (desk) {
    var tabs = "";
    var ativo = ' class="ativo"';
    $(".listagem-home .lista-imoveis").each(function (i, el) {
      tabs +=
        '<a href="#"' +
        ativo +
        "><span>" +
        $(".tit-listagem", this).text() +
        "</span></a>";
      ativo = "";
    });
    $(".listagem-home .tit").after(
      '<div class="tab-listas">' + tabs + "</div>"
    );

    $(".listagem-home .tab-listas a").on("click", function (e) {
      e.preventDefault();
      var eq = $(this).index();
      $(this).addClass("ativo").siblings().removeClass("ativo");
      $(".listagem-home .lista-imoveis").removeClass("ativo");
      $(".listagem-home .lista-imoveis:eq(" + eq + ")").addClass("ativo");

      $(".listagem-home .lista-imoveis:eq(" + eq + ") .img:not(imgtobg)").each(
        function (i, el) {
          var src = $("img", el).hide().data("src");
          //$(el).addClass('imgtobg').css({'background-image': 'url(' + src + ')'});
        }
      );
    });

    $(".listagem-home .link-todos")
      .removeClass("link-todos")
      .addClass("bt-todos");
  }

  // CONVERSAO
  $(".lista-conversao a, .bt-conversao .submenu a, .bt-open-modal").on(
    "click",
    function (e) {
      e.preventDefault();
      var target = $(this).data("target");
      var time = $("#modalConversaoPrincipal").is(":visible") ? 500 : 0;
      $("#modalConversaoPrincipal").modal("hide");
      setTimeout(function () {
        $(target).modal("show");
      }, time);
    }
  );

  ///////// FORMULARIOS

  // 1. Mascara
  $("input[data-mask-tel]:not(:disabled)").each(function (i, el) {
    $(el).mask(SPMaskBehavior, spOptions);
  });
  $("input[data-mask-ddi]").each(function (i, el) {
    $(el).mask("+009");
  });
  $("input[data-mask]:not(:disabled)").on("keypress", function (e) {
    if (e.key.replace(/\D/g, "").length == 0) return false;
  });

  // 2. Tipo Contato Institucional
  $(".tipo-contato-inst").on("change", function () {
    var form = $(this).parents("form");
    var tipo = $("option:selected", this).data("tipo");
    console.log(tipo);

    $(".form-group:not(.form-group-fornecedor)", form).removeClass("d-none");
    $(".form-group-fornecedor", form)
      .addClass("d-none")
      .find("input")
      .prop("disabled", true);
    $(".imprensa", form).addClass("d-none");

    if (tipo == 3) {
      $(".form-group-fornecedor", form)
        .removeClass("d-none")
        .find("input")
        .prop("disabled", false);
    }
    if (tipo == 4) {
      $(".form-group:not(:first-of-type)", form).addClass("d-none");
      $(".imprensa", form).removeClass("d-none");
    }
    if (tipo == 5) {
      $('input[name="destinatario"]').val('juridico@setin.com.br');
    } else{ 
      $('input[name="destinatario"]').val('relacionamento@setin.com.br');
    }
  });

  // 3. Tipo Cadastro Portal Cliente
  $(".check-tipo-cadastro").on("change", function () {
    var form = $(this).parents("form");
    if ($(this).val() == "F") {
      $(".form-group-tipo1", form)
        .css("display", "block")
        .find("input")
        .prop("disabled", false);
      $(".form-group-tipo2", form).hide().find("input").prop("disabled", true);
    } else {
      $(".form-group-tipo2", form)
        .css("display", "block")
        .find("input")
        .prop("disabled", false);
      $(".form-group-tipo1", form).hide().find("input").prop("disabled", true);
    }
  });

  // 4. Tipo Contato Modal
  $(".modal .select-tipo-contato").on("change", function (e) {
    var tipo = this.value;
    var modal = $(this).parents(".modal");

    $("form", modal).removeClass("was-validated");

    $(".form", modal).addClass("d-none");

    if (tipo == 1) {
      $(".form:eq(0)", modal).removeClass("d-none");
    } else {
      $(".form:eq(1)", modal).removeClass("d-none");
      $(".tipo-contato-inst", modal)
        .find('option[data-tipo="' + (tipo - 1) + '"]')
        .prop("selected", true);
      $(".tipo-contato-inst", modal).trigger("change");
    }
  });

  $(".inputfile input").on("click", function (e) {
    $(this).val("");
  });
  // 5. Input File
  $(".inputfile input").on("change", function (e) {
    var limitSize = 11219617;
    var fileName = "";
    var textExceptions = "";
    var validate = true;

    if (this.files) {
      $(this)
        .parent()
        .find(".limit-size-extensions-file, .filename")
        .css("display", "block");
    }
    if (this.files && this.files.length > 1)
      fileName = this.files.length + " arquivos";
    else fileName = e.target.value.split("\\").pop();

    $(this).parent().find(".filename").html(fileName);
    $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .find("button.btn.btn-primary")
      .attr("disabled", true);

    var extArquivo = this.value.split(".").pop();

    if ($(this).parent().find(".info").data("validatefile").length > 0) {
      var extPermitidas = $(this)
        .parent()
        .find(".info")
        .data("validatefile")
        .split(",")
        .map(String);
      console.log(
        typeof extPermitidas.find(function (ext) {
          return extArquivo == ext;
        })
      );
      var message = $(this)
        .parent()
        .find(".limit-size-extensions-file")
        .text("");
      if (
        typeof extPermitidas.find(function (ext) {
          return extArquivo == ext;
        }) == "undefined"
      ) {
        $(this)
          .parent()
          .find(".filename")
          .html(fileName + '<div class="close">x</div>');
        message = $(this)
          .parent()
          .find(".limit-size-extensions-file")
          .text(
            "Somente as seguintes extensões são aceitas: " +
              extPermitidas.join(", ") +
              ". Limite de 10 MB."
          );
        validate = false;
      }
      if (this.files[0].size > limitSize) {
        $(this)
          .parent()
          .find(".filename")
          .html(fileName + '<div class="close">x</div>');
        message = $(this)
          .parent()
          .find(".limit-size-extensions-file")
          .text("Tamanho de arquivo permitido excedido. (Máx. 10 MB)");
        validate = false;
      }
    }
    $(this)
      .parent()
      .find(".filename .close")
      .on("click", function () {
        $(".filename").css("display", "none");
      });
    if (validate)
      $(this)
        .parent()
        .parent()
        .parent()
        .parent()
        .find("button.btn.btn-primary")
        .attr("disabled", false);
  });

  // 6. Telefone Código Pais
  $(".form-check-ddi input").on("change", function () {
    var $formGroup = $(this).parents(".form-group");

    if (this.checked) {
      $formGroup.addClass("exibe-ddi");
      $formGroup.find(".form-control-ddi").prop("disabled", false);
      $("[data-mask-tel]", $formGroup)
        .mask("999999999999")
        .attr({ minlength: 5, maxlength: 10, placeholder: "Ex.: 99999999" });
    } else {
      $formGroup.removeClass("exibe-ddi");
      $formGroup.find(".form-control-ddi").prop("disabled", true);
      $("[data-mask-tel]", $formGroup)
        .mask(SPMaskBehavior, spOptions)
        .attr({
          minlength: 14,
          maxlength: 15,
          placeholder: "Ex.: (11) 99999-9999",
        });
    }
  });

  // 7. Validando checkbox de aceite
  $("input[name=Aceito_Contato_Email]").each(function (i, el) {
    el.setCustomValidity("invalido");
  });
  $(
    "input[name=Aceito_Contato_Email], input[name=Aceito_Contato_WhatsApp], input[name=Aceito_Contato_Telefone]"
  ).on("change", function () {
    var $form = $(this).parents("form");
    if (
      $("input[name=Aceito_Contato_Email]", $form).get(0).checked ||
      $("input[name=Aceito_Contato_WhatsApp]", $form).get(0).checked ||
      $("input[name=Aceito_Contato_Telefone]", $form).get(0).checked
    ) {
      $("input[name=Aceito_Contato_Email]", $form).get(0).setCustomValidity("");
    } else {
      $("input[name=Aceito_Contato_Email]", $form)
        .get(0)
        .setCustomValidity("invalido");
    }
  });

  // MODAIS

  // 1. Modal Breve Lançamento
  $("#modalBreve").on("show.bs.modal", function (event) {
    var bt = $(event.relatedTarget);
    var tit = bt.data("tit");
    var empreend = bt.data("empreend");
    var idhyp = bt.data("idhyp");
    var modal = $(this);
    modal.find(".modal-title").text(tit + " - " + empreend);
    modal.find('input[name="id_produto"]').val(idhyp);
    modal.find('input[name="produto"]').val(empreend + " - " + idhyp);
    modal
      .find("textarea")
      .val("Olá, gostaria de mais informações sobre o " + empreend + ".");
    modal.find("form").attr({ "data-empreend": empreend });
    eventos("Contato", "Abrir Email", empreend);
  });

  // 2. Modal Institucional
  $(".abreModalInst").on("click", function (e) {
    e.preventDefault();
    var time = $(".modal:visible").length > 0 ? 500 : 0;
    $(".modal:visible").modal("hide");
    setTimeout(function () {
      $("#modalInstitucional").modal("show");
    }, time);
  });

  // 3. Modal Email
  $("#modalEmail").on("show.bs.modal", function (event) {
    var nome = $("#formChatProd_Nome").val();
    var email = $("#formChatProd_Email").val();
    var tel = $("#formChatProd_Telefone").val();

    nome = nome === undefined ? "" : nome;
    email = email === undefined ? "" : email;
    tel = tel === undefined ? "" : tel;

    if (nome != "") $("#formEmail_Nome").val(nome);
    if (email != "") $("#formEmail_Email").val(email);
    if (tel != "") $("#formEmail_Telefone").val(tel);
  });

  // 4. Modal Chat
  $("#modalChat").on("show.bs.modal", function (event) {
    var nome = $("#formEmailProd_Nome").val();
    var email = $("#formEmailProd_Email").val();
    var tel = $("#formEmailProd_Telefone").val();

    nome = nome === undefined ? "" : nome;
    email = email === undefined ? "" : email;
    tel = tel === undefined ? "" : tel;

    if (nome != "") $("#formChat_Nome").val(nome);
    if (email != "") $("#formChat_Email").val(email);
    if (tel != "") $("#formChat_Telefone").val(tel);
  });

  // 6. Ajuste bug iphone
  $(".modal").on("show.bs.modal", function (event) {
    setTimeout(function () {
      $("body.iphone").css("position", "fixed");
    }, 300);
  });
  $(".modal").on("hide.bs.modal", function (event) {
    $("body.iphone").css("position", "initial");
  });

  // TAGUEAMENTO DE EVENTOS
  tagueamento();

  // SETIN VENDAS APP
  if (location.href.indexOf("setinvendas") > -1) {
    if (location.hash == "#app") {
      $("body").addClass("app");
      document.cookie = "app=ok; made_write_conn=1295214458; Path=/;";
    } else {
      var verifica = document.cookie;
      if (verifica.indexOf("app=ok") >= 0) {
        $("body").addClass("app");
      } else {
        $("body").addClass("site");
      }
    }
  }

  // VALIDACAO REALTIME
  $(".form-control, .custom-select").on("blur", function () {
    if ($(this).is(":invalid")) $(this).addClass("is-invalid");
    else $(this).removeClass("is-invalid");
  });

  // POPUP COOKIE
  $(".popup-aviso-cookie button").on("click", function () {
    cookie.set("box_closed", true, 365);
    $(".popup-aviso-cookie").addClass("hide");
    setTimeout(() => {
      $(".popup-aviso-cookie").remove();
    }, 400);
  });

  $(".input_whats_mascara").on("input", function () {
    let inputWhats = $(this).val();
    let btnWhats = $('#btn_whats_mascara');
    let btnWhatsDesk = $('#btn_whats_mascara_desk');
    if (inputWhats.length >= 15) {
        btnWhats.prop('disabled', false);
        btnWhatsDesk.prop('disabled', false);
    } else {
        btnWhats.prop('disabled', true);
        btnWhatsDesk.prop('disabled', true);
    }
  });

});

const animation = (scrollTop) => {
  document.querySelectorAll(".animation:not(.start)").forEach((el) => {
    if (offset(el).top < scrollTop + window.innerHeight * 0.95)
      el.classList.add("start");
  });
};

const offset = (el) => {
  const rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
};

var SPMaskBehavior = function (val) {
    return val.replace(/\D/g, "").length === 11
      ? "(00) 00000-0000"
      : "(00) 0000-00009";
  },
  spOptions = {
    clearIfNotMatch: false,
    onKeyPress: function (val, e, field, options) {
      field.mask(SPMaskBehavior.apply({}, arguments), options);
    },
  };

window.abrirPopup = function (url) {
  var janela = window.open(url, "popup", "width=640,height=480");
  janela.focus();
};

  window.toggleWhatsAppDialog = () => {
    let dialog = document.getElementById('whatsappDialog');
    if (!dialog) {
        console.error("Elemento #whatsappDialog não encontrado.");
        return;
    }
    dialog.style.display = (dialog.style.display === 'none' || dialog.style.display === '') ? 'flex' : 'none';
  };

  window.openWhatsApp = (e) => {
		var masckWhats = '';
		if(document.getElementById('whatsappNumber')){
		  masckWhats = document.getElementById('whatsappNumber');
		}
		if(document.getElementById('whatsappNumberMob')){
		  masckWhats = document.getElementById('whatsappNumberMob');
		}
	
		let dialog = document.getElementById('whatsappDialog');
		if (!dialog) {
			console.error("Elemento #whatsappDialog não encontrado.");
			return;
		}
	
		dialog.style.display = (dialog.style.display === 'none' || dialog.style.display === '') ? 'flex' : 'none';
		
		let whatsappLink = 'https://api.whatsapp.com/send?phone=551130414646&text=Ol%C3%A1%2C%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20um%20apartamento%20da%20Setin'

		
    const sessionPhone = window.getTrackingData();
    sessionPhone.local = 'home';
    var settings = {
		  "url": "/api/leadPhone",
		  "method": "POST",
		  "timeout": 0,
		  "headers": {
			"Content-Type": "application/json"
		  },
		  "data": JSON.stringify({ 
			  telefone: '55' + masckWhats.value.replace(/\D/g, ""),
			  ...sessionPhone
      }),
		};
		
		$.ajax(settings).done(function (response) {
      //window.open(whatsappLink, '_blank');
		});
  
		var settings = {
		  "url": "https://setin.hubid360.com.br/api/leadphone",
		  "method": "POST",
		  "timeout": 0,
		  "headers": {
			"Content-Type": "application/json"
		  },
		  "data": JSON.stringify({ 
			  telefone: '55' + masckWhats.value.replace(/\D/g, ""),
			  ...sessionPhone
      }),
		};
		
		$.ajax(settings).done(function (response) {
      window.open(whatsappLink, '_blank');
		});
		
  };

window.functionEventoFaceView = function () {
  // Verificar se o evento já foi disparado
  if (window.viewContentEventTriggered) {
    return;
  }

  // Calcular percentagem da altura total da página
  const documentHeight = $(document).height();
  const windowHeight = $(window).height();
  const scrollPosition = $(window).scrollTop() + windowHeight;
  const percentageViewed = (scrollPosition / documentHeight) * 100;

  // Disparar quando atingir 50% da página
  if (percentageViewed >= 50) {
    try{
      window.viewContentEventTriggered = true;
      fbTrackEvent("ViewContent");
      $(window).off("scroll", window.functionEventoFaceView);
    } catch (error) {
      console.error("Error tracking ViewContent event:", error);
    }
  }
};

$(window).on("scroll", window.functionEventoFaceView);

/// VALIDACAO FORMULARIOS
(function () {
  "use strict";
  window.sendSafetyControl = false;
  window.addEventListener(
    "load",
    function () {
      var forms = document.getElementsByClassName("needs-validation");
      var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            var $form = $(form);
            var empreend = $form.data("empreend");
            var tipo = $form.data("tipo");

            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();

              $(".form-control:invalid ~ .invalid-feedback", $form).each(
                function () {
                  eventos("Contato", "Erro", $(this).text());
                }
              );
            } else {
              eventos("Contato", "Enviar " + tipo, empreend);

              window.dataLayer.push ({
                'event': 'Sucesso ' + tipo
              });

              // Integração HubSpot
              if (tipo == "Email" || tipo == "WhatsApp" || tipo == "Chat") {
                var $contato_email = $(
                  "input[name=Aceito_Contato_Email]",
                  $form
                );
                var $contato_zap = $(
                  "input[name=Aceito_Contato_WhatsApp]",
                  $form
                );
                var origem = "";
                var ref_raw = "";
                var referrer = "";
                var dados = $("input,select,textarea", $form)
                  .filter(":not(disabled)")
                  .serialize();

                if (cookie.get("hubid_rawref")) {
                  var cookie_hubid = JSON.parse(
                    atob(cookie.get("hubid_rawref"))
                  );
                  origem = cookie_hubid.origem ? cookie_hubid.origem : "";
                  ref_raw = cookie_hubid.url ? cookie_hubid.url : "";
                  referrer = cookie_hubid.referrer ? cookie_hubid.referrer : "";
                }

                $.ajaxSetup({
                  headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                      "content"
                    ),
                  },
                });
                $.ajax({
                  type: "GET",
                  url: "/api/empreendimentos/lead/",
                  data:
                    dados +
                      "&empreend=" +
                      empreend +
                      "&title=" +
                      document.title +
                      "&Referencia=" +
                      origem +
                      "&ReferenciaRaw=" +
                      encodeURIComponent(ref_raw) +
                      "&Referrer=" +
                      encodeURIComponent(referrer) +
                      "&IP=" +
                      window.ip_client +
                      "&FormConf=" +
                      tipo +
                      "&Aceito_Contato_Email=" +
                      ($contato_email.is(":checked") ? "SIM" : "") +
                      "&Aceito_Contato_WhatsApp=" +
                      ($contato_zap.is(":checked") ? "SIM" : "") +
                      "&Pagina=" +
                      document.location.pathname ?? "",
                  success: function (data) {
                    if (data == 204) {
                      console.log("Sucesso - HubSpot");
                    }
                  },
                  error: function (jqXHR, textStatus, errorThrown) {
                    console.log(textStatus, errorThrown);
                  },
                });
              }
              // Fim HubSpot

              if ($(form.Email).hasClass("nosafetymails")) {
                return validaSafetyMails($(form.Email), false);
              }
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    false
  );

  $("input.nosafetymails")
    .on("input", function () {
      $(this).removeClass("valido erro is-invalid");
      $(this).get(0).setCustomValidity("");
      $(this).addClass("nosafetymails");
    })
    .on("blur", function () {
      if ($(this).is(":valid")) {
        var $this = $(this);
        setTimeout(function () {
          validaSafetyMails($this, true);
        }, 500);
      }
    });

  var password = document.getElementById("FC_Senha");
  var confirm_password = document.getElementById("FC_ConfirmarSenha");

  if (password != null) {
    function validatePassword() {
      if (password.value != confirm_password.value) {
        confirm_password.setCustomValidity("Senhas diferentes!");
      } else {
        confirm_password.setCustomValidity("");
      }
    }

    password.onchange = validatePassword;
    confirm_password.onkeyup = validatePassword;
  }

  
  
  
  // VALIDA SAFETY MAILS
  function validaSafetyMails($el, async) {
    if ($el.val().indexOf("teste@teste.com") >= 0) {
      var $form = $el.parents("form");
      $form.find("button").prop("disabled", false);
      $el.removeClass("nosafetymails erro is-invalid");
      $el.get(0).setCustomValidity("");
      return;
    }

    if (
      !$el.hasClass("validando") &&
      !$el.hasClass("valido") &&
      !$el.hasClass("erro")
    ) {
      $el.addClass("validando");
      var $form = $el.parents("form");
      var email = b64EncodeUnicode($el.val());
      var key = "be3c11605563fc1eecee6aa1fce057f81e988c55";
      var ticket =
        location.href.indexOf("dev.id360.net") > -1
          ? "ca24c6e65d29135199725ea61abde5a11424713d" // dev
          : location.href.indexOf("setin.com.br") > -1
          ? "0d892add1b79e97fcc9b0f57bbeb43d8f6a3246f" // prod
          : "47255688e229bf0f2f920fb441dd520189fb5b27"; // local

      setTimeout(function () {
        $.ajax({
          dataType: "json",
          url:
            "https://optin.safetymails.com/main/safetyapi/" +
            key +
            "/" +
            ticket +
            "/" +
            email,
          data: "",
          async: async,
          success: function (r) {
            console.warn("Status SafetyMails: " + r.Status);
            if (
              r.Status == "INVALIDO" ||
              r.Status == "ERRO_SINTAXE" ||
              r.Status == "SPAMTRAP_POSSIVEL" ||
              r.Status == "DOMINIO_INVALIDO"
            ) {
              $el.addClass("erro is-invalid");
              $el.get(0).setCustomValidity("Inválido!");
              console.error("email invalido");
              $form.find("button").prop("disabled", true);
            } else {
              $el
                .removeClass("nosafetymails erro is-invalid")
                .addClass("valido");
              $el.get(0).setCustomValidity("");
              $form.find("button").prop("disabled", false);
              if ($form.find("input[name=validadoSafetyMails]").length > 0) {
                $form.find("input[name=validadoSafetyMails]").val("Sim");
              } else {
                console.error("Campo de controle do SafetyMails ausente");
              }
            }
          },
          error: function () {
            $el.removeClass("nosafetymails erro is-invalid").addClass("valido");
            $el.get(0).setCustomValidity("");
          },
          complete: function () {
            $el.removeClass("validando");

            if (window.sendSafetyControl) {
              $form.find(".btn").trigger("click");
            }
          },
        });
      }, 100);
    }
  }

  function b64EncodeUnicode(str) {
    return btoa(
      encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
          return String.fromCharCode("0x" + p1);
        }
      )
    );
  }
})();

// INTEGRACAO HUBID
hubid_callback = function (state, form, channel, message, lead_id) {
  var $form = $(form);
  var empreend = $form.data("empreend");
  var tipo = $form.data("tipo");
  var mensagem = "";
  var $container = $form.parents(".form").length ? $form.parents(".form") : $form;

  if ($form.find(".msg").length == 0) {
    $form.find("button.btn").after('<div class="msg"></div>');
  }

  var $msg = $container.find(".msg");

  $msg.on("click", function (e) {
    e.preventDefault();
    $msg.removeClass("msg-ativo");
    if ($container.hasClass("form-sucess")) {
      $(".modal.show").modal("hide");
    }
    $container.removeClass("form-sending form-sucess form-error");
    setTimeout(function () {
      $msg.html();
    }, 200);
  });

  switch (state) {
    case "loading":
      $container.addClass("form-sending");
      break;
    case "error":
      $container.addClass("form-error");
      mensagem = "";
      $msg.addClass("msg-ativo");
      $msg.html(
        '<h3>ERRO AO ENVIAR</h3><p>Informe o administrador do sistema.</p><a href="#" class="bt icon-close"></a>'
      );
      break;
    case "success":
      $container.addClass("form-sucess");
      $form.removeClass("was-validated");

      // track facebook
      if (form.assunto.value === 'Quero comprar um imóvel') {
        console.log('lead track');
        fbTrackEvent('Lead');
      }

      // track pinterest
      pintrk("track", "lead", { lead_type: "Newsletter" });

      // track tiktok
      let ddi_tiktok = "+55";
      if (form.DDI) {
        ddi_tiktok = form.DDI.value !== "" ? form.DDI.value : "+55";
      }
      ttq.identify({
        email: form.Email.value,
        phone_number: ddi_tiktok + form.Telefone.value.replace(/\D/g, ""),
      });
      ttq.track("Contact");

      if (tipo === "Institucional" || tipo === "Email" || tipo === "Chat") {
        eventos("Contato", "Sucesso " + tipo, empreend);
        window.dataLayer.push({ event: "Sucesso " + tipo });
      }

      $form
        .removeClass("was-validated")
        .find(".form-control")
        .removeClass("valido erro erro-sintaxe");

      $msg.addClass("msg-ativo");
      $msg.html(
        '<h3>DADOS ENVIADOS COM SUCESSO!</h3><p>Obrigado por entrar em contato.</p><a href="#" class="bt icon-close"></a>'
      );

      if (channel.match(/(whatsapp|chat|videoconferencia)/)) {
        $(".form-sucess .msg .bt").trigger("click");
      }

      if (tipo === "Chatbot") {
        session.chatbot_lead_id = lead_id;
        session.nome = form.Nome.value;
        session.email = form.Email.value;
        session.telefone = form.Telefone.value;

        // DADOS HISTORICO LEAD
        if (cookie.get("hubid_rawref")) {
          let cookie_hubid = JSON.parse(atob(cookie.get("hubid_rawref")));
          session.referencia_raw = cookie_hubid.url ? cookie_hubid.url : "";
          session.referencia = cookie_hubid.referrer ? cookie_hubid.referrer : "";
          session.origem = cookie_hubid.origem ? cookie_hubid.origem : "";
        }

        if (cookie.get("hubid_user")) {
          let cookie_user = JSON.parse(atob(cookie.get("hubid_user")));
          session.historico_id = cookie_user.history_id
            ? cookie_user.history_id
            : "";
        }

        $(".form-sucess .msg .bt").trigger("click");
        openChatbot();
      }

      break;
  }
};

// GA EVENTOS
window.eventos = function (categoria, acao, rotulo) {
  ga("send", "event", categoria, acao, rotulo);
};

function tagueamento() {
  // HOME
  $("header .bt-menu").on("click", function () {
    if ($("header").hasClass("open-menu"))
      eventos("Header", "Clique", "Abrir Menu");
  });
  $("header .logo-header a").on("click", function () {
    eventos("Header", "Clique", "Logo Setin");
  });
  $("header .menu-principal a, header .menu-apoio nav a").on(
    "click",
    function () {
      eventos("Header", "Clique", $(this).text());
    }
  );
  $("header .busca-header form").on("submit", function () {
    eventos("Header", "Buscar", "Buscar");
  });
  $(".bt-conversao > a").on("click", function () {
    eventos("Contato", "Clique", $(this).text());
  });
  $(".bt-conversao .submenu li a").on("click", function () {
    eventos("Contato", "Clique", $(this).text());
  });
  $(".abreModalInst").on("click", function () {
    eventos("Contato", "Abrir", "Outro assuntos");
  });
  $(".lista-conversao a").on("click", function () {
    eventos("Contato", "Escolha Modal", $(this).text());
  });

  $(".banner-home .owl-prev").on("click", function () {
    eventos("Banner Home", "Rotate", "Seta Esquerda");
  });
  $(".banner-home .owl-next").on("click", function () {
    eventos("Banner Home", "Rotate", "Seta Direita");
  });
  $(".banner-home .owl-dot").on("click", function () {
    eventos("Banner Home", "Clique", "Bullets");
  });
  $(".banner-home .item").on("click", function () {
    eventos("Banner Home", "Clique", "Posição " + $(this).data("pos"));
  });

  $(".tipo-home a").on("click", function () {
    eventos("Vitrine Tipologia", "Clique", $(this).text());
  });

  $(".listagem-home .bt-todos").on("click", function () {
    eventos(
      "Carrossel " + $(".lista-imoveis.ativo .tit-listagem").text(),
      "Clique",
      "Ver Todos"
    );
  });
  $(".listagem-home .link-todos").on("click", function () {
    eventos(
      "Carrossel " + $(this).siblings(".tit-listagem").text(),
      "Clique",
      "Ver Todos"
    );
  });
  $(".listagem-home .item").on("click", function () {
    var status = $(".lista-imoveis.ativo .tit-listagem").text();
    var nome = $(this).find(".nome").text();
    eventos("Carrossel " + status, "Clique", nome);
  });

  $(".conteudo-premium a").on("click", function () {
    eventos("Destaque Conteúdo", "Clique", $(this).text());
  });
  $(".localizacao-home a").on("click", function () {
    eventos("Vitrine Mapa", "Clique", $(this).text());
  });
  $(".diferenciais-home .listagem-videos a").on("click", function () {
    eventos(
      "Vitrine Diferenciais",
      "Clique " + ($(this).index() + 1),
      $(this).text()
    );
  });
  $(".diferenciais-home .bt-todos").on("click", function () {
    eventos("Vitrine Diferenciais", "Clique", $(this).text());
  });

  $(".posts-home .post a").on("click", function () {
    var pos = $(this).parents('[class^="col"]').index() + 1;
    var titpost = $(this).parent().find(".tit-post").text();
    eventos("Vitrine Conteúdo", "Clique " + pos, titpost);
  });
  $(".posts-home .bt-todos").on("click", function () {
    eventos("Vitrine Conteúdo", "Clique", $(this).text());
  });
  $(".blog-revista a").on("click", function () {
    eventos("Vitrine Conteúdo", "Clique", $(this).find(".tit").text());
  });

  $("footer a").on("click", function () {
    eventos("Footer", "Clique", $(this).text());
  });

  $(".newsletter form").on("submit", function () {
    var rotulo = this.checkValidity() ? "Sucesso" : "Erro";
    eventos("Newsletter", "Enviar", rotulo);
  });

  $('.modal input[name="Aceito_Contato_Email"]').on("change", function () {
    if (this.checked) eventos("Contato", "Opt-In", "Email");
  });
  $('.modal input[name="Aceito_Contato_WhatsApp"]').on("change", function () {
    if (this.checked) eventos("Contato", "Opt-In", "WhatsApp");
  });

  // LISTAGEM
  $(".filtros #tipo_imovel").on("change", function () {
    eventos("Filtro Listing", "Filtrar Tipo", $(":selected", this).text());
  });
  $(".filtros #status_imovel").on("change", function () {
    eventos("Filtro Listing", "Filtrar Status", $(":selected", this).text());
  });
  $(".filtros #localizacao_imovel").on("change", function () {
    eventos(
      "Filtro Listing",
      "Filtrar Localização",
      $(":selected", this).text()
    );
  });
  $(".barra-filtros .bts a:not(.bt-filtros)").on("click", function () {
    eventos("Visualização Listing", "Clique", $(this).text());
  });
  $(".mapa-cards").on("click", ".content", function () {
    eventos("Listing Mapa", "Clique", $(this).find(".nome").text());
  });
  $(".mapa-cards").on("click", ".gmnoprint", function () {
    eventos("Listing Mapa", "Clique", "Logo Setin");
  });
  $(".mapa-cards .zoom-mapa").on("click", ".zoom-mais", function () {
    eventos("Listing Mapa", "Zoom", "Ampliar");
  });
  $(".mapa-cards .zoom-mapa").on("click", ".zoom-menos", function () {
    eventos("Listing Mapa", "Zoom", "Reduzir");
  });

  // FICHA
  $(".menu-ficha a").on("click", function () {
    eventos("Ficha Produto", "Clique", $(this).text());
  });
  $(".banner-ficha .bt-scroll").on("click", function () {
    eventos("Ficha Produto", "Clique", $(this).text());
  });
  $(".infos-ficha .selo .item").on("click", function () {
    eventos("Ficha Produto", "Clique", "Selo Promocional");
  });
  $(".diferenciais-ficha .ver-todos").on("click", function () {
    eventos(
      "Diferenciais",
      "Clique",
      $(this).find("span:visible").siblings().text()
    );
  });
  $(".diferenciais-ficha .block-header").on("click", function () {
    eventos("Diferenciais", "Clique", $(this).find(".tit-block").text());
  });
  $(".diferenciais-ficha .owl-prev").on("click", function () {
    eventos("Diferenciais", "Alternar", "Seta Esquerda");
  });
  $(".diferenciais-ficha .owl-next").on("click", function () {
    eventos("Diferenciais", "Alternar", "Seta Direita");
  });
  $(".diferenciais-ficha .owl-dot").on("click", function () {
    eventos("Diferenciais", "Alternar", "Bullets");
  });
  $(".sobre-ficha .texto-lermais .bt").on("click", function () {
    eventos("Sobre o Produto", "Clique", "Ler Mais");
  });
  $(".localizacao-ficha .texto-lermais .bt").on("click", function () {
    eventos("Localização", "Clique", "Ler Mais");
  });

  $(".mapa-ficha .bt-explorar").on("click", function () {
    eventos("Localização", "Clique", "Explorar");
  });
  $(".mapa-ficha .box .bt").on("click", function () {
    eventos("Localização", "Clique", "Como chegar");
  });
  $(".mapa-ficha .visualizacao a").on("click", function () {
    eventos("Localização", "Alterar Visualização", $(this).text());
  });
  $(".mapa-ficha .places a").on("click", function () {
    eventos("Localização", "Destacar na região", $(this).text());
  });
  $(".mapa-ficha .zoom-mais").on("click", function () {
    eventos("Localização", "Zoom", "Ampliar");
  });
  $(".mapa-ficha .zoom-menos").on("click", function () {
    eventos("Localização", "Zoom", "Reduzir");
  });

  $(".galeria-ficha .item").on("click", function () {
    eventos(
      "Galeria de Imagens",
      "Ampliar Imagem",
      $(this).find(".legenda").text()
    );
  });
  $(".galeria-ficha .owl-prev").on("click", function () {
    eventos("Galeria de Imagens", "Alternar Imagens", "Seta Esquerda");
  });
  $(".galeria-ficha .owl-next").on("click", function () {
    eventos("Galeria de Imagens", "Alternar Imagens", "Seta Direita");
  });
  $(".galeria-ficha .owl-dot").on("click", function () {
    eventos("Galeria de Imagens", "Alternar Imagens", "Bullets");
  });

  $(".plantas-ficha .nav-plantas .legenda").on("click", function () {
    eventos("Galeria de Plantas", "Alternar Plantas", $(this).text());
  });
  $(".plantas-ficha .item a").on("click", function () {
    eventos(
      "Galeria de Plantas",
      "Ampliar Planta",
      $(this).find("img").attr("alt")
    );
  });
  $(".plantas-ficha .owl-prev").on("click", function () {
    eventos("Galeria de Plantas", "Alternar Plantas", "Seta Esquerda");
  });
  $(".plantas-ficha .owl-next").on("click", function () {
    eventos("Galeria de Plantas", "Alternar Plantas", "Seta Direita");
  });
  $(".plantas-ficha .bt-tour, .tour-ficha .bt a").on("click", function () {
    eventos("Tour Virtual", "Clique", $(this).text());
  });

  $(".videos-diferenciais-ficha .video").on("click", function () {
    eventos(
      "Vitrine Diferenciais",
      "Clique " + ($(this).parent().index() + 1),
      $(this).find(".tit-video").text()
    );
  });
  $(".videos-diferenciais-ficha .owl-prev").on("click", function () {
    eventos("Vitrine Diferenciais", "Alternar Diferenciais", "Seta Esquerda");
  });
  $(".videos-diferenciais-ficha .owl-next").on("click", function () {
    eventos("Vitrine Diferenciais", "Alternar Diferenciais", "Seta Direita");
  });

  $(".obras-ficha .owl-prev").on("click", function () {
    eventos("Status da Obra", "Alternar Imagens", "Seta Esquerda");
  });
  $(".obras-ficha .owl-next").on("click", function () {
    eventos("Status da Obra", "Alternar Imagens", "Seta Direita");
  });
  $(".obras-ficha .item a").on("click", function () {
    eventos(
      "Status da Obra",
      "Ampliar Imagem",
      $(this).find(".legenda").text()
    );
  });

  $(".contato-ficha .btn, .contato-ficha .bt").on("click", function () {
    eventos("Contato Ficha", "Clique", $(this).text());
  });

  $(".semelhantes-ficha .item").on("click", function () {
    eventos("Imóveis Semelhantes", "Clique", $(this).find(".nome").text());
  });
  $(".semelhantes-ficha .owl-prev").on("click", function () {
    eventos("Imóveis Semelhantes", "Alternar", "Seta Esquerda");
  });
  $(".semelhantes-ficha .owl-next").on("click", function () {
    eventos("Imóveis Semelhantes", "Alternar", "Seta Direita");
  });
  $(".semelhantes-ficha .owl-dot").on("click", function () {
    eventos("Imóveis Semelhantes", "Alternar", "Bullets");
  });

  $(".ficha .texto-legal-ficha").on("click", function () {
    eventos("Ficha Produto", "Clique", $(this).text());
  });

  // CAMPANHA
  $(".campanha .texto-legal-ficha a").on("click", function () {
    eventos("LP Promocional", "Clique", $(this).text());
  });
}

// COOKIES
window.cookie = {
  set: (name, value, days = 0, path = "/") => {
    let expires =
      days === 0 ? "" : new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name +
      "=" +
      value +
      "; expires=" +
      expires +
      "; path=" +
      path +
      "; SameSite=Lax;";
  },

  get: (name) => {
    return document.cookie.split("; ").reduce((r, v) => {
      const parts = v.split("=");
      return parts[0] === name ? parts[1] : r;
    }, null);
  },

  del: (name) => cookie.set(name, "", -1),
};

// Home and Header
window.addEventListener("load", () => {
  const mainSearchBox = document.querySelector("#main-search-box");
  const municipio = mainSearchBox?.querySelector('input[name="municipio"]');
  const bairro = mainSearchBox?.querySelector('input[name="bairro"]');
  const dorms = mainSearchBox?.querySelector('input[name="dorms"]');
  const localizacao = mainSearchBox?.querySelector('input[name="localizacao"]');
  const selectRegions = mainSearchBox?.querySelector(
    ".main-search-box__select--region"
  );
  const selectDorms = mainSearchBox?.querySelector(
    ".main-search-box__select--dorms"
  );
  const selectBoxes = mainSearchBox?.querySelectorAll(
    ".main-search-box__select.main-search-box__select"
  );
  selectBoxes?.forEach((selectBox) => {
    const selectedText = selectBox.querySelector(
      ".main-search-box__selected-text"
    );
    selectBox.querySelectorAll(".search-box-dropdown__item").forEach((item) => {
      item.addEventListener("click", () => {
        selectDorms.classList.remove("main-search-box__select--opacity");
        municipio.value = item.getAttribute("data-municipio");
        bairro.value = item.getAttribute("data-bairro");
        localizacao.value = item.getAttribute("data-localizacao");
        if (item.getAttribute("data-dorms-default"))
          dorms.value = item.getAttribute("data-dorms-default");
        else
          getDorms(
            item.getAttribute("data-municipio"),
            item.getAttribute("data-bairro")
          );
        selectedText.innerHTML = item.innerHTML;
      });
    });
  });

  document.querySelectorAll(".main-search-box").forEach((mainSearchBox) => {
    mainSearchBox.querySelector("button").addEventListener("click", (e) => {
      const dorms = mainSearchBox.querySelector('input[name="dorms"]').value;
      const bairro = mainSearchBox.querySelector('input[name="bairro"]').value;
      const localizacao = mainSearchBox.querySelector(
        'input[name="localizacao"]'
      ).value;
      let q = localizacao
        ? "localizacao=" + localizacao + "&dorms=" + dorms
        : "bairro=" + bairro + "&dorms=" + dorms;
      window.location.href = `/imoveis-a-venda/todos/?${q}`;
    });
  });

  document.querySelectorAll(".main-search-box__select").forEach((selectBox) => {
    selectBox.addEventListener("click", (e) => {
      e.currentTarget
        .querySelector(".search-box-dropdown")
        .classList.toggle("search-box-dropdown--inactive");
      e.currentTarget
        .querySelector(".icon-arrow-down")
        .classList.toggle("icon-arrow-down--rotate");
    });
  });

  selectRegions?.addEventListener("click", (e) => {
    let dorms = document.querySelector(
      ".search-box-dropdown.search-box-dropdown--dorms.search-box-dropdown--inactive"
    );
    if (!dorms)
      document
        .querySelector(".search-box-dropdown.search-box-dropdown--dorms")
        .classList.add("search-box-dropdown--inactive");
  });
  selectDorms?.addEventListener("click", (e) => {
    let regions = document.querySelector(
      ".search-box-dropdown.search-box-dropdown--region.search-box-dropdown--inactive"
    );
    if (!regions)
      document
        .querySelector(".search-box-dropdown.search-box-dropdown--region")
        .classList.add("search-box-dropdown--inactive");
  });

  window.toggleFocusSearchBox = () => {
    document
      .querySelector("#search-box-header")
      .classList.toggle("search-box--active");
  };
  window.toggleSideMenu = () => {
    document
      .querySelector("#mobile-side-menu-btn")
      .classList.toggle("mobile-navbar__menu-btn--close");
    document
      .querySelector("#mobile-side-menu")
      .classList.toggle("side-menu--openned");
    document.querySelector("#backdrop").classList.toggle("backdrop--openned");
  };
  window.toggleMobileSearchBox = () => {
    document
      .querySelector("#mobile-search-box")
      .classList.toggle("mobile-navbar__search-box--visible");
  };
});

function getDorms(municipio_id, bairro) {
  const mainSearchBox = document.querySelector("#main-search-box");
  const selectBox = mainSearchBox.querySelector(
    ".main-search-box__select--dorms"
  );
  let content = mainSearchBox.querySelector(
    ".main-search-box__select--dorms .search-box-dropdown__content"
  );
  const selectedText = selectBox.querySelector(
    ".main-search-box__selected-text"
  );
  const dorms = mainSearchBox.querySelector('input[name="dorms"]');
  selectedText.innerHTML = "Aguarde...";
  while (content.firstChild) content.removeChild(content.firstChild);
  fetch(`api/dormitorios/${municipio_id}/${bairro}`)
    .then((resp) => resp.json())
    .then(function (data) {
      data.map(function (item) {
        selectedText.innerHTML = "E com quantos dorms?";
        let searchBoxDropdown = document.createElement("div");
        searchBoxDropdown.className = "search-box-dropdown__item";
        searchBoxDropdown.innerHTML = item.dormitorios;
        searchBoxDropdown.dataset.dorms = item.dormitorios;
        searchBoxDropdown.addEventListener("click", () => {
          selectedText.innerHTML = searchBoxDropdown.innerHTML;
          dorms.value = slug(searchBoxDropdown.innerHTML);
        });
        content.appendChild(searchBoxDropdown);
      });
    });
}
function slug(texto) {
  return texto
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[áàäâã]/g, "a")
    .replace(/[éèëê]/g, "e")
    .replace(/[íìîï]/g, "i")
    .replace(/[óòöôõ]/g, "o")
    .replace(/[úùüû]/g, "u")
    .replace(/ñ/g, "n")
    .replace(/ç/g, "c")
    .replace(/\-\-+/g, "-");
}

function shouldShowButton() {
  const now = new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo" });
  const currentTime = new Date(now);
  const currentHour = currentTime.getHours();
  const currentMinutes = currentTime.getMinutes();

  console.log("Horário atual:", currentHour, ":", currentMinutes); // Debug
  console.log("Botão visível?", (currentHour >= 23 || (currentHour >= 0 && currentHour < 9) || (currentHour === 9 && currentMinutes === 29))); // Debug

  return (currentHour >= 23 || (currentHour >= 0 && currentHour < 9) || (currentHour === 9 && currentMinutes === 29));
}

function updateButtonVisibility() {
  const button = document.querySelector('.floating-whatsapp-button');
  if(button){
    if (shouldShowButton()) {
      button.classList.remove('floating-whatsapp-button--hidden');
      return true;
  } else {
      button.classList.add('floating-whatsapp-button--hidden');
      return false;
  }
  }
  
}

/* Select Custom Listagem */
const dropdowns = document.querySelectorAll(".filtros-select-menu");

dropdowns.forEach((dropdown) => {
  const select = dropdown.querySelector(".filtros-select");
  const selected = dropdown.querySelector(".filtros-selected");
  const menu = dropdown.querySelector(".filtros-option-list");
  const options = dropdown.querySelectorAll(".filtros-option");
  select.addEventListener("click", () => {
    menu.classList.toggle("active");
    select.querySelector(".icon-arrow-down").classList.toggle("icon-arrow-up");
  });
  options.forEach((option) => {
    option.addEventListener("click", (e) => {
      selected.innerHTML = option.innerHTML;
      menu.classList.toggle("active");
      select
        .querySelector(".icon-arrow-down")
        .classList.toggle("icon-arrow-up");
      options.forEach((option) => {
        option.classList.remove("active");
      });
      option.classList.add("active");
      let parameters = "";
      document.querySelectorAll(".filtros-option.active").forEach((option) => {
        parameters += "/" + option.dataset.url;
      });
      parameters = parameters.split("/?").join("?").split("/?").join("?");
      if (parameters[parameters.length - 1] == "/")
        parameters = parameters.slice(0, parameters.length - 1);
      window.location.href = `/imoveis-a-venda${parameters}`;
    });
  });
});
/***************************************************************************/
